/** Shared photography for service detail pages (structural, site, and envelope work). */
import site1 from '../assets/images/about/projectBeforeWork.webp';
import ext1 from '../assets/images/gallery/extensions/beforeWall.webp';
import ext2 from '../assets/images/gallery/extensions/doors.webp';
import ext3 from '../assets/images/gallery/extensions/openDoors.webp';
import ext4 from '../assets/images/gallery/extensions/shaunWhole.webp';
import ext5 from '../assets/images/gallery/extensions/shaunWhole2.webp';
import roof1 from '../assets/images/gallery/roofing/DSC02024.webp';
import roof2 from '../assets/images/gallery/roofing/DSC02025.webp';
import out1 from '../assets/images/gallery/outdoors/projectBeforeWhole.webp';
import out2 from '../assets/images/gallery/outdoors/projectBeforeWork2.webp';
import svcExt from '../assets/images/services/extension.webp';
import svcRoof from '../assets/images/services/roof.webp';

export const IMG_PRE_CONSTRUCTION = [site1, ext1, ext2, ext3, ext4, ext5];
export const IMG_NEW_BUILD = [svcExt, ext1, ext2, out1, out2, ext4];
export const IMG_COMMERCIAL = [ext3, ext4, ext5, roof1, roof2, svcRoof];
export const IMG_STRUCTURAL = [out1, out2, site1, ext1, ext2, ext3];
export const IMG_FIT_OUT = [ext4, ext5, ext2, ext3, roof2, svcExt];
export const IMG_DESIGN_COORD = [ext1, ext3, ext5, site1, ext4, ext2];
export const IMG_SITE_HANDOVER = [roof1, roof2, svcRoof, out1, site1, ext5];
